'use client';
import React from "react";
import "./comparison-cards.css";

export default function ComparisonCards() {
    return (
        <div id="comparison-cards-parents">
            <div className="comparison-cards">
                <div className="card std-benefits">
                    <div className="card-header">STD BENEFITS</div>
                    <ul className="benefits-list">
                        <li>- Access to 45+ SA Resorts using Bonus Breaks</li>
                        <li>- Access International Resorts through exchanges</li>
                        <li>- Book SA Cruises</li>
                    </ul>
                </div>
                <div className="card plus-benefits">
                    <div className="card-header">PLUS BENEFITS</div>
                    <div className="benefits-highlight" >All Existing Off Beat Benefits</div>
                    <br/>
                    <div className="plus">PLUS</div>
                    <ul className="benefits-list">
                        <li>- Up to R120 back on meals at 2,000+ Restaurants</li>
                        <li>- Up to 50% OFF movies, popcorn & drink combos</li>
                        <li>- Up to 50% OFF 1 million + Hotels and Resorts Worldwide</li>
                        <li>- Up to 20% OFF Cruises at 5,000 exotic destinations</li>
                        <li>- Save on Flights, Car Hire and Activities</li>
                        <li>- Up to 50% OFF local deals & seasonal specials</li>
                        <li>- 20% OFF Spa Deals</li>
                    </ul>
                    <div className="pricing">FROM R99 PM</div>
                </div>
            </div>
        </div>
    );
}